import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

import { Dropdown } from '@verantos-dev/shared-components';

import { useMetricProjectsDropdown } from './useMetricProjectsDropdown';

export const MetricProjectsDropdown = () => {
  const { formatMessage } = useIntl();

  const { projectOptions, handleProjectChange, isProjectsLoading, selectedProjectId } =
    useMetricProjectsDropdown();

  return (
    <Box>
      <Dropdown
        id="metrics-project-dropdown"
        options={projectOptions}
        onChange={handleProjectChange}
        label={formatMessage({ id: 'workspaceCommon.content.dropdown.project.label' })}
        placeholder={formatMessage({ id: 'workspaceCommon.content.dropdown.project.placeholder' })}
        disabled={isProjectsLoading || projectOptions.length === 0}
        width="medium"
        value={selectedProjectId ?? ''}
      />
    </Box>
  );
};
